import { render, staticRenderFns } from "./OptionHealthLifeTreatmentYN.vue?vue&type=template&id=71ca097a"
import script from "./OptionHealthLifeTreatmentYN.vue?vue&type=script&lang=js"
export * from "./OptionHealthLifeTreatmentYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports